import { gql } from "@apollo/client";

export const READ_ONE_LICENSE_TEMPLATE_NAME = "ReadOneLicenseTemplate";
export const READ_ONE_LICENSE_TEMPLATE_QUERY = gql`
  query ${READ_ONE_LICENSE_TEMPLATE_NAME}($id_license: Int!) {
    licenses {
      templates {
        by_id(id_license: $id_license) {
          name
        }
      }
    }
  }
`;

export const READ_LICENSE_TEMPLATE_LIMITS_NAME = "ReadLicenseTemplateLimits";
export const READ_LICENSE_TEMPLATE_LIMITS_QUERY = gql`
  query ${READ_LICENSE_TEMPLATE_LIMITS_NAME}($id_license: Int!) {
    licenses {
      templates {
        by_id(id_license: $id_license) {
          limits {
            enable
            value
            id_limit
            limit_type {
              name
              description
            }
          }
        }
      }
    }
  }
`;

export const READ_LICENSE_TEMPLATE_FEATURES_NAME =
  "ReadLicenseTemplateFeatures";
export const READ_LICENSE_TEMPLATE_FEATURES_QUERY = gql`
    query ${READ_LICENSE_TEMPLATE_FEATURES_NAME}($id_license: Int!) {
    licenses {
      templates {
        by_id(id_license: $id_license) {
          features {
            id_feature
            is_enabled
            feature_type {
              name
              description
              feature_groups {
                name
                description
                id_feature_group
              }
            }
          }
        }
      }
    }
  }
`;

export const READ_LICENSE_TEMPLATE_ACCOUNTS_QUERY = gql`
  query ReadLicenseTemplateAccounts($id_license: Int!) {
    licenses {
      templates {
        by_id(id_license: $id_license) {
          ipmps {
            id_ipmp
            name
            description
            enabled
          }
        }
      }
    }
  }
`;

export const UPDATE_LICENSE_TEMPLATE_FEATURE_TYPE_QUERY = gql`
  mutation UpdateLicenseTemplateFeatureType(
    $id_feature: Int!
    $is_enabled: Boolean!
  ) {
    update_features(id_feature: $id_feature, is_enabled: $is_enabled) {
      success
      message
    }
  }
`;

export const UPDATE_LICENSE_TEMPLATE_LIMIT_QUERY = gql`
  mutation UpdateLicenseTemplateLimit(
    $id_limit: Int!
    $enable: Boolean
    $value: Int
  ) {
    update_license_limit(id_limit: $id_limit, enable: $enable, value: $value) {
      success
      message
    }
  }
`;

export const READ_LICENSE_TEMPLATE_SUGGEST = gql`
  query ReadLicenseTemplateSuggest {
    licenses {
      license_limits {
        default_value
        description
        enable
        name
        id_limit_type
      }
      license_feature_groups {
        name
        features {
          id_feature_type
          is_enabled_by_default
          name
        }
      }
    }
  }
`;

export const CREATE_LICENSE_TEMPLATE = gql`
  mutation CreateLicenseTemplate(
    $description: String
    $limits: [InputLimit]!
    $name: String!
    $features: [InputFeature]!
  ) {
    create_license_template(
      name: $name
      limits: $limits
      features: $features
      description: $description
    ) {
      success
      message
    }
  }
`;

export const UPDATE_LICENSE_TEMPLATE = gql`
  mutation UpdateLicenseTemplate(
    $description: String
    $name: String!
    $id_license: Int!
  ) {
    update_license_template(
      id_license: $id_license
      name: $name
      description: $description
    ) {
      success
      message
    }
  }
`;

export const DELETE_LICENSE_TEMPLATE = gql`
  mutation DeleteLicenseTemplate($ids: [Int!]!) {
    delete_license_template(ids: $ids) {
      success
      message
    }
  }
`;

export const READ_FULL_ONE_LICENSE_TEMPLATE_QUERY_NAME =
  "ReadFullOneLicenseTemplate";
export const READ_FULL_ONE_LICENSE_TEMPLATE_QUERY = gql`
  query ${READ_FULL_ONE_LICENSE_TEMPLATE_QUERY_NAME}($id_license: Int!) {
    licenses {
      templates {
        by_id(id_license: $id_license) {
          features {
            id_feature_type
            is_enabled
          }
          limits {
            id_limit_type
            value
            enable
          }
        }
      }
      license_feature_groups {
        name
        features {
          id_feature_type
          name
        }
      }
      license_limits {
        id_limit_type
        description
        name
      }
    }
  }
`;
